import {createDigitalCertificateBaseQuery} from './createDigitalCertificateBaseQuery';

export const dmsBaseQuery = createDigitalCertificateBaseQuery({
  baseUrl: process.env.API_URL,
});
